enum EcommerceCardFieldEnum {
    NAME = "name",
    SKU = "sku",
    MSRP = "msrp",
    PRICE = "price",
    SHORT_DESCRIPTION = "shortDescription",
    LONG_DESCRIPTION = "longDescription",
    CATEGORY = "category",
    // The ordering customer's par level for the item (van-sell / pre-sell aid). Only offered in the
    // settings list, rendered, and present on the wire (`customer_par_qty`) when the supplier has
    // `has_par_levels`.
    PAR = "par",
    // The purchase-controls block (qty input, UOM selector, item options, Add To Cart);
    // orderable as a single unit, never hideable
    ACTIONS = "actions",
}

export default EcommerceCardFieldEnum;
